export default {
  
  name: 'Checkbox',
  
  inheritAttrs: false,
  
  props: {
    type: {
      default: 'checkbox'
    }
  },
  
  data: () => ({
    checked: null
  }),
  
  computed: {
    
    value: function(){
      return this.$attrs.value;
    }
    
  },
  
  watch: {
    
    '$attrs.checked': function(){
      
      this.checked = this.$attrs.checked;
      
    }
    
  },
    
  mounted: function(){
    
    var label = this.$el;
    var checkbox = label.querySelector('input[type="checkbox"],input[type="radio"]');
        
    checkbox.addEventListener( 'click', ( e ) => {
      
      this.updateChecked( e.target.checked );
      
      if( e.target.type == 'radio' ){
        
        var inputs = e.target.closest('form').querySelectorAll( 'input[type="radio"][name="' + e.target.name + '"]' );
        
        inputs.forEach( ( input ) => {
          
          if( input != e.target ){
            input.dispatchEvent( new CustomEvent('reset') );
          }
          
        });
        
      }
      
    });
    
    checkbox.addEventListener( 'reset', this.updateChecked.bind( this, false ) );
    
    this.checked = this.$attrs.checked;
                      
  },
  
  methods: {
    
    updateChecked: function( checked ){
      this.checked = checked;
    },
    
    focus: function(){
      this.focused = true;
    },
    
    blur: function(){
      this.focused = false;
    },
    
    change: function( e ){
      this.$emit( 'input', e.target.checked ? e.target.value : null );
    }
    
  },
  
  render: function(h){
    
    return (
      <label class={{ 'checked': this.checked, 'focused': this.focused }} data-checkbox>
        <input type={ this.type } ref="input"
          vOn:change={ this.change } vOn:focus={ this.focus } vOn:blur={ this.blur }
          name={ this.$attrs.name }
          value={ this.$attrs.value }
          checked={ this.checked }
          tabindex={ this.$attrs.tabindex }
          { ...this.$attrs }
        />
        { this.$slots.default }
      </label>
    );
    
  }
  
};